export const enum EventStatusType {
    Live = 'live',
    Scheduled = 'scheduled',
    Finished = 'finished',
    Cancelled = 'cancelled',
    Interrupted = 'interrupted',
    Deleted = 'deleted',
    Other = 'other'
}

export interface SportStatus {
    id: number
    name: string
    short_name: string
    type: EventStatusType
}
